import { render, staticRenderFns } from "./tallyDetailsModal.vue?vue&type=template&id=8e913d86"
import script from "./tallyDetailsModal.vue?vue&type=script&lang=js"
export * from "./tallyDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports